import style from './TransferNotification.module.scss'

interface IProps {
    transferableContractError: string
    onAccept: () => void
    onReject: () => void
}

export const TransferNotification = (props: IProps) => {
    const { transferableContractError, onAccept, onReject } = props
    const serverMessage = JSON.parse(transferableContractError)?.error || 'Не читаемое уведомление от сервера'
    return (
        <div className={style.container}>
            <div className={style.serverMessageWrapper}>
                <span>{serverMessage}</span>
            </div>
            <div className={style.actionsWrapper}>
                <button onClick={onAccept}>ДА</button>
                <button onClick={onReject}>НЕТ</button>
            </div>
        </div>
    )
}
